/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-14 11:11:11
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-20 13:48:17
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 申样表
export const OrderList = params => {
	return request({
		url: '/api/sample-order/list/',
		data: params,
		method: AjaxMethod.post,
	});
};

// 确认带货
export const OrderAffirm = params => {
	return request({
		url: '/api/sample-order/affirm',
		params: params,
		method: AjaxMethod.get,
	});
};

// 拒绝带货
export const OrderRefuse = params => {
	return request({
		url: '/api/sample-order/refuse',
		params: params,
		method: AjaxMethod.get,
	});
};

// 发货
export const OrderDeliver = params => {
	return request({
		url: '/api/sample-order/deliver',
		data: params,
		method: AjaxMethod.post,
	});
};

// 物流公司列表
export const expressList = params => {
	return request({
		url: '/api/express/list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 确认商品机制变更
export const affirmChange = params => {
	return request({
		url: '/api/sample-order/affirm-change',
		params: params,
		method: AjaxMethod.get,
	});
};

// 修改商品机制变更
export const editProduct = params => {
	return request({
		url: '/api/sample-order/edit-product',
		data: params,
		method: AjaxMethod.post,
	});
};

// 团长筛选列表 该暂时接口不能分页
export const commonList = params => {
	return request({
		url: '/api/common/user-list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 合作阶段商品详情
export const cooperateDetail = params => {
	return request({
		url: '/api/cooperate/detail',
		params: params,
		method: AjaxMethod.get,
	});
};

// 选品表
export const anchorProduct = params => {
	return request({
		url: '/api/anchor-product/list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 待播表
export const waitingList = params => {
	return request({
		url: '/api/waiting-live/list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 开播表
export const liveList = params => {
	return request({
		url: '/api/live/list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 已关闭
export const closeList = params => {
	return request({
		url: '/api/product-cooperate/end-list',
		params: params,
		method: AjaxMethod.get,
	});
};

// 申请样品
export const orderAdd = params => {
	return request({
		url: '/api/sample-order/add',
		data: params,
		method: AjaxMethod.post,
	});
};

// 移除商品
export const liveRemove = params => {
	return request({
		url: '/api/waiting-live/remove',
		data: params,
		method: AjaxMethod.post,
	});
};

// 上传货盘链接
export const editUrl = params => {
	return request({
		url: '/api/waiting-live/edit-url',
		data: params,
		method: AjaxMethod.post,
	});
};

// 校验链接
export const confirmUrl = params => {
	return request({
		url: '/api/waiting-live/confirm-url',
		data: params,
		method: AjaxMethod.post,
	});
};

// 移除选品表
export const productDel = params => {
	return request({
		url: '/api/anchor-product/del',
		data: params,
		method: AjaxMethod.post,
	});
};

// 确认开播
export const confirmLive = params => {
	return request({
		url: '/api/waiting-live/confirm-live',
		data: params,
		method: AjaxMethod.post,
	});
};

// 开播表-结束合作
export const cooperationEnd = params => {
	return request({
		url: '/api/live/end-cooperation',
		data: params,
		method: AjaxMethod.post,
	});
};

// 拒绝发货
export const refuseDeliver = params => {
	return request({
		url: '/api/sample-order/deliver',
		data: params,
		method: AjaxMethod.post,
	});
};

// 样品订单导出
export const exportApply = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/export-list',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 申样表导出
export const exportSampleList = (data, notOrigin = true) => {
	return request({
		url: '/api/sample-order/export-cooperate-sample-list',
		data,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 导出选品表
export const exportSelection = (params, notOrigin = true) => {
	return request({
		url: '/api/anchor-product/export',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 导出待播表
export const exportTobe = (params, notOrigin = true) => {
	return request({
		url: '/api/waiting-live/export',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 导出开播表
export const liveExport = (params, notOrigin = true) => {
	return request({
		url: '/api/live/export',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 批量发货
export const batchSend = params => {
	return request({
		url: '/api/sample-order/batch-send',
		data: params,
		method: AjaxMethod.post,
	});
};

// 导出失败的订单
export const batchFail = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/export-batch-fail',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 状态列表项
export const statusList = params => {
	return request({
		url: '/api/common/status-list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取达人招商列表 该接口暂时不能分页
export const partnerList = params => {
	return request({
		url: '/api/common/expert-partner-list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 样品订单删除商品
export const orderRemove = params => {
	return request({
		url: '/api/sample-order/remove',
		data: params,
		method: AjaxMethod.post,
	});
};

// 合作进度样品表删除商品
export const cooperateSampleRemove = params => {
	return request({
		url: '/api/sample-order/cooperate-remove',
		data: params,
		method: AjaxMethod.post,
	});
};

// 收货地址
export const defaultSite = params => {
	return request({
		url: '/api/sample-order/get-default-site',
		data: params,
		method: AjaxMethod.post,
	});
};

// 默认收货地址
export const anchorDefaultSite = params => {
	return request({
		url: '/api/sample-order/anchor-default-site',
		data: params,
		method: AjaxMethod.post,
	});
};
// 合作进度首页公共统计数据
export const homeStat = params => {
	return request({
		url: '/api/anchor-product/home-stat',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 校验链接
export const convertUrl = params => {
	return request({
		url: '/api/waiting-live/convert-url',
		data: params,
		method: AjaxMethod.post,
	});
};

// 确认收货
export const confirmation = params => {
	return request({
		url: '/api/sample-order/delivery-confirmation',
		data: params,
		method: AjaxMethod.post,
	});
};

// 确认收货
export const nosampleLive = params => {
	return request({
		url: '/api/anchor-product/no-sample-live',
		data: params,
		method: AjaxMethod.post,
	});
};

// 修改物流信息
export const updShipping = params => {
	return request({
		url: '/api/sample-order/upd-shipping-sn',
		data: params,
		method: AjaxMethod.post,
	});
};

// 停止合作
export const stopCooperation = data => {
	return request({
		url: '/api/live/stop-cooperation',
		data,
		method: AjaxMethod.post,
	});
};

// 重新合作
export const reCooperation = data => {
	return request({
		url: '/api/live/re-cooperation',
		data,
		method: AjaxMethod.post,
	});
};

// 移除商品
export const delCooperation = data => {
	return request({
		url: '/api/live/del-cooperation',
		data,
		method: AjaxMethod.post,
	});
};

// 效果数据列表
export const effectList = data => {
	return request({
		url: '/api/live/effect-data-list',
		data,
		method: AjaxMethod.post,
	});
};

// 删除效果数据
export const delEffectData = data => {
	return request({
		url: '/api/live/del-effect-data',
		data,
		method: AjaxMethod.post,
	});
};

// 添加效果数据
export const addEffectData = data => {
	return request({
		url: '/api/live/add-effect-data',
		data,
		method: AjaxMethod.post,
	});
};

// 修改开始时间
export const updateStartTime = data => {
	return request({
		url: '/api/live/update-start-time',
		data,
		method: AjaxMethod.post,
	});
};

// 获取授权链接
export const authorizeUrl = data => {
	return request({
		url: '/api/anchor-auth/dy-authorize-url',
		data,
		method: AjaxMethod.post,
	});
};

// 补发样品
export const reissueSample = data => {
	return request({
		url: '/saas-api/cooperate/partner/sample-order/reissue-add',
		data,
		method: AjaxMethod.post,
	});
};

// 修改申样信息
export const updateSample = data => {
	return request({
		url: '/api/sample-order/upd-delivery-info',
		data,
		method: AjaxMethod.post,
	});
};

// 批量删除选品表
export const batchDel = data => {
	return request({
		url: 'api/anchor-product/batch-del',
		data,
		method: AjaxMethod.post,
	});
};

// 包裹列表
export const getDeliverList = data => {
	return request({
		url: '/api/sample-order/get-delivery-info',
		data,
		method: AjaxMethod.post,
	});
};

// 包裹列表v2
export const getDeliverListV2 = data => {
	return request({
		url: '/api/sample-order/get-delivery-info-v2',
		data,
		method: AjaxMethod.post,
	});
};
// 包裹列表
export const editProductId = data => {
	return request({
		url: '/api/waiting-live/edit-product-id',
		data,
		method: AjaxMethod.post,
		mock: true,
	});
};

// 合作进度 提交录入达人档期
export const cooperationAuthorSchedule = data => {
	return request({
		url: '/api/waiting-live/set-anchor-schedule',
		data,
		method: AjaxMethod.post,
	});
};

// 合作进度 补寄样 获取地址接口
export const cooperationGetAddress = data => {
	return request({
		url: '/api/sample-order/get-address',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取快递公司模版
export const getCompanyXlsxUrl = params => {
	return request({
		url: '/api/express/get-company-xlsx-url',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 获取交付审核详情
export const getDeliveryAuditDetail = params => {
	return request({
		url: '/api/waiting-live/delivery-detail',
		params,
		method: AjaxMethod.get,
	});
};
// 交付审核 - 通过
export const deliveryAuditPass = data => {
	return request({
		url: '/api/waiting-live/delivery-approve',
		data,
		method: AjaxMethod.post,
	});
};
// 交付审核 - 拒绝
export const deliveryAuditReject = data => {
	return request({
		url: '/api/waiting-live/delivery-reject',
		data,
		method: AjaxMethod.post,
	});
};
// 交付审核 - 编辑
export const deliveryAuditEdit = data => {
	return request({
		url: '/api/waiting-live/delivery-edit',
		data,
		method: AjaxMethod.post,
	});
};

// 已交付 - 查看交付内容
export const getDeliveryContent = params => {
	return request({
		url: '/api/live/delivery-detail',
		params,
		method: AjaxMethod.get,
	});
};

// 已交付 - 编辑带货截图
export const deliveryEdit = data => {
	return request({
		url: '/api/live/delivery-edit',
		data,
		method: AjaxMethod.post,
	});
};
